const FADE_DURATION = 0.25;

const els = {
    $galleries: () => $('[data-gallery'),
    $items: ($gallery) => $gallery.find('[data-gallery-item]'),
    $options: ($gallery) => $gallery.find('[data-gallery-option]'),
    $optionOverlay: ($option) => $option.find('[data-gallery-option-overlay]'),
    $optionOverlays: ($options) => $options.find('[data-gallery-option-overlay]'),
};

const layers = {
    fading: 2,
    visible: 1,
    hidden: 0,
};

let updating = false;

const setActiveItem = ($gallery, $item, animate = false) => {

    if (updating) return;

    updating = true;

    const index = $item.index();

    const $items = els.$items($gallery);
    const $options = els.$options($gallery);
    const $optionOverlays = els.$optionOverlays($options);

    const $option = $options.eq(index);
    const $optionOverlay = els.$optionOverlay($option);

    const $otherItems = $items.not($item);
    const $otherOptions = $options.not($option);
    const $otherOptionOverlays = $optionOverlays.not($optionOverlay);

    $otherItems.removeAttr('data-active');
    $otherOptions.removeAttr('data-active');

    $item.attr('data-active', '1');
    $option.attr('data-active', '1');

    gsap.set($optionOverlay, { opacity: 0, });
    gsap.set($otherOptionOverlays, {opacity: '' });

    if (animate) {

        gsap.set($item, { opacity: 0 });
        gsap.set($item, { zIndex: layers.fading });
        gsap.to(
            $item,
            {
                opacity: 1,
                duration: FADE_DURATION,
                onComplete: () => {
                    gsap.set($otherItems, { zIndex: layers.hidden });
                    gsap.set($item, { zIndex: layers.visible });
                    updating = false;
                },
            }
        );
    } else {
        gsap.set($item, { zIndex: layers.visible });
        gsap.set($otherItems, { zIndex: layers.hidden });
        updating = false;
    }
};

const registerEventListeners = ($gallery) => {

    const $items = els.$items($gallery);
    const $options = els.$options($gallery);

    $options.on('click', (event) => {

        const $option = $(event.currentTarget);
        const index = $option.index();
        const $item = $items.eq(index);

        setActiveItem($gallery, $item, true);
    });
};

const initializeGallery = ($gallery) => {

    const $items = els.$items($gallery);

    setActiveItem($gallery, $items.first());

    registerEventListeners($gallery);

    gsap.to($gallery, { autoAlpha: 1 });
};

const initialize = () => {

    els.$galleries().each(
        (index, element) => {
            initializeGallery($(element));
        }
    );
};

export default {
    initialize,
};

